/** Which Cricket8 product this share preview represents. Image is the same for every share. */
export type OgShareGame =
    | "site"
    | "squares"
    | "bullion"
    | "trader"
    | "results"
    | "friends"
    | "sixes"
    | "leagues";

export const DEFAULT_CDN_ENDPOINT = "https://dyatkw7msrzcb.cloudfront.net";

const DEFAULT_OG_IMAGE = "c8-og.jpg";

/** Every website share preview uses the same 1200×630 image. */
export function resolveOgShareImageUrl(
    _game: OgShareGame = "site",
    cdnEndpoint?: string
): string {
    const base = String(cdnEndpoint ?? process.env.CDN_ENDPOINT ?? DEFAULT_CDN_ENDPOINT).replace(/\/$/, "");
    return `${base}/${DEFAULT_OG_IMAGE}`;
}
